Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var hooks = require('@alfalab/hooks');
var browser = require('../browser.js');

function useCustomWebkitScrollbar() {
    var _a = react.useState(false), shouldUseCustomScrollbar = _a[0], setShouldUseCustomScrollbar = _a[1];
    hooks.useLayoutEffect_SAFE_FOR_SSR(function () {
        if (browser.browser.getScrollbarSize() > 0 && browser.browser.isWebkitBased()) {
            setShouldUseCustomScrollbar(true);
        }
    }, []);
    return shouldUseCustomScrollbar;
}

exports.useCustomWebkitScrollbar = useCustomWebkitScrollbar;
